module.exports = __webpack_public_path__ + "img/上海贝岭.4c4c2853.jpg";